import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';

const Index = () => {
    const location = useLocation();
    
    // Set the document title based on the current route
    useEffect(() => {
        // Default title for the admin panel
        let title = "Koottu Admin Panel";
        
        // Special title for login page
        if (location.pathname === '/login') {
            title = "Koottu Admin SignIn";
        }
        
        // Special title for SMS logs page
        if (location.pathname === '/sms-logs') {
            title = "SMS Logs";
        }
        
        // Set the document title
        document.title = title;
    }, [location.pathname]);
    
    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    {route.component}
                                </NonAuthLayout>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected>
                                    <VerticalLayout>{route.component}</VerticalLayout>
                                </AuthProtected>}
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>
            </Routes>
        </React.Fragment>
    );
};

export default Index;